import differenceInMinutes from 'date-fns/differenceInMinutes';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './Timelapse.module.scss';

interface Props {
  timestamp: string;
}

const Timelapse: React.FC<Props> = ({ timestamp }) => {
  const intl = useIntl();

  if (timestamp) {
    const timelapse = differenceInMinutes(new Date(), new Date(timestamp));
    const isSmallTimelapse = timelapse <= 10;
    const isMediumTimelapse = timelapse > 10 && timelapse <= 60;

    const timelapseClassName = isSmallTimelapse
      ? styles.greenText
      : isMediumTimelapse
      ? styles.yellowText
      : styles.redText;

    return (
      <div className={timelapseClassName}>
        {intl.formatMessage(
          {
            id:
              timelapse && timelapse > 300
                ? 'dataManagement.dataQuality.bigTimelapse'
                : 'dataManagement.dataQuality.timelapse',
          },
          { minutes: timelapse },
        )}
      </div>
    );
  }

  return <div />;
};

export default Timelapse;
